<div class="dashboard-item">
  <div class="grid-container">
    <div class="grid-item dashboard-item-label">{{label}}</div>
    <div class="grid-item dashboard-item-value"> {{value}} </div>
  </div>
</div>
